import module from './module.js'
/* Components */
import './components/components.js'
/* Services */
/* Routes */

export default module.name



// WEBPACK FOOTER //
// ./src/herramientas/index.js